"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.object.assign.js");
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); } /**
                                                                                                                                                                                                                                                                                                                                                    * Global components
                                                                                                                                                                                                                                                                                                                                                    * By Bhargav Shivaprasad <bshivaprasad@svb.com> (www.svb.com)
                                                                                                                                                                                                                                                                                                                                                    * Summary
                                                                                                                                                                                                                                                                                                                                                    * This component renders an SVB Tab example
                                                                                                                                                                                                                                                                                                                                                    */
/**
 * Tab Variation - TabFull
  * @param {array} items - Array of string to render the label
  * @param {string} activeItem - Item that needs to be highlighted/Selected Tab Item
  * @param {boolean} showBorder - shows a full width border below all the tabs
  * @param {function} onPress - returns item name that is being clicked
  * @returns JSX element
 */
const TabFull = _ref => {
  let {
    items,
    activeItem,
    showBorder,
    onPress
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "d-flex svb-tab-container".concat(showBorder ? " tab-border" : "")
  }, items === null || items === void 0 ? void 0 : items.map((i, ind) => {
    return /*#__PURE__*/_react.default.createElement("div", {
      key: ind,
      onClick: () => onPress(i),
      className: "tab-item ".concat((items === null || items === void 0 ? void 0 : items.length) > 1 ? ind === 0 ? "tab-left-radius " : (items === null || items === void 0 ? void 0 : items.length) - 1 === ind ? "tab-right-radius" : "" : "tab-left-radius tab-right-radius")
    }, /*#__PURE__*/_react.default.createElement("p", {
      "data-testid": "tab-test-item",
      className: "paragraph  tab-text ".concat(activeItem === i ? "tab-active bold" : "medium")
    }, i));
  }));
};
/**
 * Tab Variation - TabAsset
  * @param {array} items - Array of string to render the label
  * @param {string} activeItem - Item that needs to be highlighted/Selected Tab Item
  * @param {function} onPress - returns item name that is being clicked
  * @returns JSX element
 */
const TabAsset = _ref2 => {
  let {
    items,
    activeItem,
    onPress
  } = _ref2;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "svb-tab-asset-container"
  }, items === null || items === void 0 ? void 0 : items.map((i, ind) => {
    return /*#__PURE__*/_react.default.createElement("div", {
      onClick: () => onPress(i),
      className: "tab-item",
      key: ind
    }, /*#__PURE__*/_react.default.createElement("p", {
      "data-testid": "tab-test-item",
      className: "paragraph tab-text ".concat(activeItem === i ? "tab-active bold" : "medium")
    }, i));
  }));
};
const TabClickable = _ref3 => {
  let {
    items,
    activeItem,
    onPress,
    inActiveItemStyle = " "
  } = _ref3;
  const bgColor = {
    "color": "#afbecb"
  };
  const inActiveItemStyles = "sub-heading tab-text " + inActiveItemStyle;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "mw-tabs svb-solutions-header-container d-flex",
    "data-testid": "mw-tabs"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "container ps-3 svb-tab-container"
  }, (items === null || items === void 0 ? void 0 : items.length) > 0 && (items === null || items === void 0 ? void 0 : items.map((item, index) => {
    return /*#__PURE__*/_react.default.createElement("div", {
      key: index,
      className: index > 0 ? "ps-5" : ""
    }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
      "data-testid": "tab-test-item",
      to: item === null || item === void 0 ? void 0 : item.toLink,
      style: activeItem !== (item === null || item === void 0 ? void 0 : item.toName) ? bgColor : {},
      className: activeItem === (item === null || item === void 0 ? void 0 : item.toName) ? 'sub-heading tab-text product-font-color-white ' : {
        inActiveItemStyles
      },
      onClick: () => onPress(item === null || item === void 0 ? void 0 : item.toName)
    }, item === null || item === void 0 ? void 0 : item.name));
  }))));
};

/**
 * Grouping all Tab variations here
 */
const TabVariations = {
  "tabAsset": TabAsset,
  "tabFull": TabFull,
  "tabClickable": TabClickable
};

/**
 * SVBTabs
 * @param {string} preset - Tab variation to be rendered [tabAsset || tabFull]
 * @param {array} items - Array of string to render the label
 * @param {string} activeItem - Item that needs to be highlighted/Selected Tab Item
 * @param {boolean} showBorder - shows a full width border below all the tabs
 * @param {function} onPress - returns item name that is being clicked
 * @returns JSX element
 */
const SVBTabs = props => {
  var _props$items, _props$preset, _TabVariations$preset;
  const items = (_props$items = props === null || props === void 0 ? void 0 : props.items) !== null && _props$items !== void 0 ? _props$items : [];
  const preset = (_props$preset = props === null || props === void 0 ? void 0 : props.preset) !== null && _props$preset !== void 0 ? _props$preset : "tabFull";
  const TabVariation = (_TabVariations$preset = TabVariations[preset]) !== null && _TabVariations$preset !== void 0 ? _TabVariations$preset : TabVariations["tabFull"];
  return (items === null || items === void 0 ? void 0 : items.length) > 0 && /*#__PURE__*/_react.default.createElement(TabVariation, _extends({
    item: items
  }, props));
};
var _default = SVBTabs;
exports.default = _default;